"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToUSD = void 0;
const convertToUSD = (sumInCents = 0) => {
    return (sumInCents / 100).toFixed(2);
};
exports.convertToUSD = convertToUSD;
//# sourceMappingURL=convertToUSD.js.map